import { Helmet } from "react-helmet-async"
import { AutomationRunsList } from "../../../../../Automations"

export default function OrganizationAutomationRunsPage() {
	return (
		<>
			<Helmet>
				<title>Automation Runs</title>
			</Helmet>
			<AutomationRunsList />
		</>
	)
}
